<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Event Mission" class="mb-3" />
      </b-col>
    </b-row>
    <b-media>
      <section class="py-3">
        <div class="d-flex justify-content-between">
          <h2 class="mb-2">Event Mission</h2>
          <div>
            <loading-button
              class="mr-1"
              icon="SettingsIcon"
              variant="success"
              size="md"
              @click="openConfigPublicMissionModal"
            >
              Config public mission
            </loading-button>
            <loading-button
              icon="CheckCircleIcon"
              variant="warning"
              size="md"
              :disabled="!is_mission_changed"
              @click="updateDisplayOrder"
            >
              Update Display Mission
            </loading-button>
            <loading-button
              class="ml-1"
              icon="PlusIcon"
              variant="primary"
              size="md"
              @click="openCreateEventMissionModal"
            >
              Add
            </loading-button>
          </div>
        </div>
      </section>
    </b-media>
    <b-card>
      <mission-event-table
        :event_missions="event_missions"
        @getList="getList"
        @changeMission="changeMission"
      />
    </b-card>
    <b-pagination
      class="mt-auto"
      pills
      size="lg"
      align="center"
      v-model="current_page"
      :total-rows="total_items"
      :per-page="items_per_page"
    />
    <mission-event-form-modal ref="eventMissionFormModal" @loadData="getList" />
    <config-public-mission-form-modal ref="configPublicMissionFormModal" />
  </div>
</template>

<script>
import service from "../service";
import MissionEventTable from "./_components/MissionEventTable.vue";
import MissionEventFormModal from "./_components/MissionEventFormModal.vue";
import ConfigPublicMissionFormModal from "./_components/ConfigPublicMissionFormModal.vue";
import draggable from "vuedraggable";

export default {
  components: {
    MissionEventTable,
    MissionEventFormModal,
    ConfigPublicMissionFormModal,
    draggable,
  },
  data() {
    return {
      current_page: 1,
      total_items: 0,
      items_per_page: 50,
      event_missions: [],
      editLanguage: null,
      is_mission_changed: false,
    };
  },

  watch: {
    event_missions(value, old_value) {
      if (!old_value.length) {
        return;
      }
      if (this.is_mission_changed === false) {
        this.is_mission_changed = true;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let response = await service.getList({
        page: this.current_page,
        limit: this.items_per_page,
      });
      if (response.data.type === "DATA") {
        this.event_missions = response.data.data.list;
        this.total_items = response.data.data.total;
      }
    },

    changeMission(value) {
      this.event_missions = value;
    },

    async updateDisplayOrder() {
      const res = await service.updateDisplayOrder({
        list: this.event_missions,
      });
      if (res.data && res.data.type === "SUCCESS") {
        await this.getList();
      }
    },

    goToCreateEventMission() {
      this.$router.push({
        name: "mission-event-create",
      });
    },

    openCreateEventMissionModal() {
      this.$refs.eventMissionFormModal.openCreateModal();
    },

    openConfigPublicMissionModal() {
      this.$refs.configPublicMissionFormModal.openUpdateModal();
    },
  },
};
</script>
